import { useState, useEffect } from 'react';
import { MediaHelpers } from '@wajeez-web/core/api';
import { AudioPlayerInput } from '@wajeez-web/components/ui';

const PreviewAudioComponent = ({
  value,
  fileName,
}: {
  value: string;
  fileName?: string;
}) => {
  const [audioSrc, setAudioSrc] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!value) return;
    setIsLoading(true);
    MediaHelpers.getMediaUrlByIdAsync(value)
      .then((res) => {
        setAudioSrc(res);
        setIsLoading(false);
      })
      .catch(() => {
        setAudioSrc('');
        setIsLoading(false);
      });
  }, [value]);
  return isLoading ? (
    <div className="flex justify-center text-center">جاري التحميل ...</div>
  ) : audioSrc ? (
    <AudioPlayerInput value={audioSrc} fileName={fileName} />
  ) : (
    <div></div>
  );
};

export default PreviewAudioComponent;
